import { Vue, Component, Prop } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';

@Component({
    name: 'setup-organization',
    components: {
        'material-icons': GoogleMaterialIcon,
    },
})

export default class SetupOrganization extends Vue {

    // -------------------------------------------------------------------------
    // Properties

    @Prop()
    private cardName!: string;

    private organizationId: string = '';

    // -----------------------------------------------------------------------------
    // Actions

    private onGoNext() {
        // this.$emit('onGoNext');
    }

    private onBack() {
        this.$emit('onBack');
    }

}
